/* BlankApparel redesign — ba.js (no dependencies) */
(function () {
  'use strict';
  var BA = (window.BA = window.BA || {});
  var CITIES = [
    { col: 'bangalore', key: 'Bangalore', code: 'BLR', name: 'Bangalore' },
    { col: 'hyderabad', key: 'Hyderabad', code: 'HYD', name: 'Hyderabad' },
    { col: 'mumbai', key: 'Mumbai', code: 'MUM', name: 'Mumbai' }
  ];
  BA.CITIES = CITIES;
  var fmt = function (n) { return Number(n).toLocaleString('en-IN'); };
  BA.fmt = fmt;

  /* ---------- Selected warehouse (shared with ba-wh.js) ----------
     Like the app: one warehouse is active at a time, Bangalore by default.
     Stock everywhere on the site follows it; changing it fires `ba:wh` on document. */
  var WH_KEY = 'ba_wh', WH_DEFAULT = 'bangalore';
  BA.city = function (col) { for (var i = 0; i < CITIES.length; i++) if (CITIES[i].col === col) return CITIES[i]; return null; };
  BA.wh = {
    get: function () {
      var v = null;
      try { v = localStorage.getItem(WH_KEY); } catch (e) {}
      return BA.city(v) ? v : (BA.__wh && BA.city(BA.__wh) ? BA.__wh : WH_DEFAULT);
    },
    set: function (col) {
      if (!BA.city(col) || col === BA.wh.get()) return;
      BA.__wh = col;
      try { localStorage.setItem(WH_KEY, col); } catch (e) {}
      document.documentElement.setAttribute('data-ba-wh', col);
      document.dispatchEvent(new CustomEvent('ba:wh', { detail: { wh: col, city: BA.city(col) } }));
    },
    on: function (fn) { document.addEventListener('ba:wh', function (e) { fn(e.detail.wh); }); }
  };
  document.documentElement.setAttribute('data-ba-wh', BA.wh.get());
  /* Best other warehouse for a parsed stock row: { city, n } or null */
  BA.altWh = function (p, wh) {
    var best = null;
    CITIES.forEach(function (c) { if (c.col !== wh && p[c.col] > 0 && (!best || p[c.col] > best.n)) best = { city: c, n: p[c.col] }; });
    return best;
  };

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Header: desktop dropdowns ---------- */
  function initHeader() {
    var items = document.querySelectorAll('.ba-nav__item');
    var closeAll = function () { items.forEach(function (i) { i.classList.remove('is-open'); var b = i.querySelector('.ba-nav__top'); if (b) b.setAttribute('aria-expanded', 'false'); }); };
    items.forEach(function (item) {
      var btn = item.querySelector('.ba-nav__top');
      var t;
      item.addEventListener('mouseenter', function () { clearTimeout(t); closeAll(); item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); });
      item.addEventListener('mouseleave', function () { t = setTimeout(function () { item.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }, 120); });
      btn.addEventListener('click', function (e) {
        if (!item.querySelector('.ba-nav__panel')) return;
        e.preventDefault();
        var open = item.classList.contains('is-open');
        closeAll();
        if (!open) { item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
      });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(); closeMenu(); } });
    document.addEventListener('click', function (e) { if (!e.target.closest('.ba-nav')) closeAll(); });

    // Mobile menu
    var menu = document.querySelector('.ba-menu');
    function closeMenu() { if (!menu) return; menu.classList.remove('is-open'); document.documentElement.classList.remove('ba-lock'); }
    BA.closeMenu = closeMenu;
    document.querySelectorAll('[data-ba-menu-open]').forEach(function (b) {
      b.addEventListener('click', function () { if (!menu) return; menu.classList.add('is-open'); document.documentElement.classList.add('ba-lock'); });
    });
    document.querySelectorAll('[data-ba-menu-close]').forEach(function (b) { b.addEventListener('click', closeMenu); });
    if (menu) menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeMenu); });
  }
  function closeMenu() { if (BA.closeMenu) BA.closeMenu(); }

  /* ---------- Showcase filter ---------- */
  function initFilters() {
    document.querySelectorAll('[data-ba-filter]').forEach(function (wrap) {
      var root = wrap.closest('section') || document;
      var chips = wrap.querySelectorAll('.ba-chip');
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          chips.forEach(function (c) { c.classList.remove('is-active'); c.setAttribute('aria-pressed', 'false'); });
          chip.classList.add('is-active'); chip.setAttribute('aria-pressed', 'true');
          var f = chip.getAttribute('data-filter');
          root.querySelectorAll('[data-cat]').forEach(function (card) {
            card.hidden = !(f === 'all' || (' ' + card.getAttribute('data-cat') + ' ').indexOf(' ' + f + ' ') > -1);
          });
        });
      });
    });
  }

  /* ---------- Live stock fetch (shared, cached 60s per session) ---------- */
  BA.fetchStock = function (url, ids, opts) {
    opts = opts || {};
    var key = 'ba_stock_' + ids.slice().sort().join(',');
    if (!opts.fresh) {
      try {
        var c = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (c && Date.now() - c.t < 60000) return Promise.resolve(c.d);
      } catch (e) {}
    }
    var attempt = function (n) {
      var ctl = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 12000);
      return fetch(url + '?action=publicStockBatch&variantIds=' + ids.join(',') + '&_t=' + Date.now(), { cache: 'no-store', redirect: 'follow', signal: ctl ? ctl.signal : undefined })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (d) {
          clearTimeout(timer);
          if (!d || !d.ok || !d.results) throw new Error('Bad response');
          try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d: d.results })); } catch (e) {}
          return d.results;
        })
        .catch(function (err) {
          clearTimeout(timer);
          if (n < 3) return new Promise(function (res) { setTimeout(res, n * 1500); }).then(function () { if (opts.onRetry) opts.onRetry(n + 1); return attempt(n + 1); });
          throw err;
        });
    };
    return attempt(1);
  };
  BA.parseStock = function (stock) {
    var p = { total: 0 };
    CITIES.forEach(function (c) { var n = Math.max(0, Number(stock && stock[c.key]) || 0); p[c.col] = n; p.total += n; });
    return p;
  };

  /* ---------- Homepage inventory showcase ---------- */
  function initInventoryShowcase() {
    document.querySelectorAll('[data-ba-inv]').forEach(function (app) {
      if (app.__baInit) return; app.__baInit = true;
      var url = app.getAttribute('data-url');
      var rows = Array.prototype.slice.call(app.querySelectorAll('[data-vid]'));
      if (!url || !rows.length) return;
      var ids = rows.map(function (r) { return r.getAttribute('data-vid'); });
      var segBtns = app.querySelectorAll('.ba-seg button');
      var stamp = app.querySelector('[data-stamp]');
      var data = null, view = BA.wh.get();
      function mark() { segBtns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-view') === view); }); }
      function paint() {
        mark();
        if (!data) return;
        var max = 1;
        rows.forEach(function (r) { max = Math.max(max, BA.parseStock(data[r.getAttribute('data-vid')])[view]); });
        rows.forEach(function (r) {
          var p = BA.parseStock(data[r.getAttribute('data-vid')]);
          var n = p[view], alt = n > 0 ? null : BA.altWh(p, view);
          var q = r.querySelector('.ba-row__qty'), b = r.querySelector('.ba-row__bar i');
          q.textContent = n > 0 ? fmt(n) : alt ? 'In ' + alt.city.code : 'Out';
          q.classList.toggle('is-out', n <= 0 && !alt);
          q.classList.toggle('is-alt', n <= 0 && !!alt);
          b.style.width = (n > 0 ? Math.max(4, Math.round(n / max * 100)) : 0) + '%';
        });
        segBtns.forEach(function (btn) {
          var v = btn.getAttribute('data-view'), sum = 0;
          rows.forEach(function (r) { sum += BA.parseStock(data[r.getAttribute('data-vid')])[v] || 0; });
          var s = btn.querySelector('small'); if (s) s.textContent = fmt(sum);
        });
      }
      segBtns.forEach(function (btn) {
        btn.addEventListener('click', function () { BA.wh.set(btn.getAttribute('data-view')); });
      });
      BA.wh.on(function (wh) { view = wh; paint(); });
      mark();
      var started = false;
      var start = function () {
        if (started) return; started = true;
        BA.fetchStock(url, ids).then(function (d) {
          data = d; paint();
          if (stamp) stamp.textContent = 'Updated ' + new Date().toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
        }).catch(function () { if (stamp) stamp.textContent = 'Live data unavailable right now'; });
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { start(); io.disconnect(); } }, { rootMargin: '400px' });
        io.observe(app);
      } else start();
    });
  }

  /* ---------- Product live stock table (selected warehouse only) ---------- */
  function initProductStock() {
    document.querySelectorAll('[data-ba-stock]').forEach(function (box) {
      if (box.__baInit) return; box.__baInit = true;
      var url = box.getAttribute('data-url');
      var rows = Array.prototype.slice.call(box.querySelectorAll('tr[data-vid]'));
      if (!rows.length) return;
      var ids = rows.map(function (r) { return r.getAttribute('data-vid'); });
      var tabs = box.querySelectorAll('.ba-stock__tab');
      var status = box.querySelector('.ba-stock__status-t');
      var statusWrap = box.querySelector('.ba-stock__status');
      var refresh = box.querySelector('.ba-stock__refresh');
      var hide = box.querySelector('[data-hide-oos]');
      var note = box.querySelector('[data-wh-note]');
      var parsed = {}, loaded = false, busy = false, last = 0;
      var view = BA.wh.get();

      function setStatus(t, err) { if (status) status.textContent = t; if (statusWrap) statusWrap.classList.toggle('is-err', !!err); }
      function skeleton() {
        box.querySelectorAll('td[data-col]').forEach(function (td) { td.classList.remove('is-out', 'is-alt'); td.innerHTML = '<span class="ba-sk"></span>'; });
        tabs.forEach(function (t) { var s = t.querySelector('span'); if (s) s.innerHTML = '<span class="ba-sk"></span>'; });
      }
      function cell(td, n, p, col) {
        if (!td) return;
        td.classList.remove('is-out', 'is-alt');
        if (n === null) { td.textContent = '—'; return; }
        if (n > 0) { td.textContent = fmt(n); return; }
        var alt = p ? BA.altWh(p, col) : null;
        if (alt) {
          td.classList.add('is-alt');
          td.innerHTML = '<span class="ba-stock__none">Not here</span><button type="button" class="ba-stock__alt" data-wh-go="' + alt.city.col + '">' + fmt(alt.n) + ' in ' + alt.city.name + '</button>';
        } else { td.classList.add('is-out'); td.textContent = 'Out'; }
      }
      // Quantity can't exceed what the selected warehouse holds; sizes it doesn't have are locked.
      function lockQty() {
        rows.forEach(function (r) {
          var input = r.querySelector('.ba-qty input');
          if (!input) return;
          if (!input.hasAttribute('data-max0')) input.setAttribute('data-max0', input.getAttribute('max') || '');
          var p = parsed[r.getAttribute('data-vid')];
          var base = parseInt(input.getAttribute('data-max0'), 10);
          if (!loaded || !p) { input.disabled = false; if (input.getAttribute('data-max0')) input.max = base; else input.removeAttribute('max'); return; }
          var n = p[view];
          var mx = isNaN(base) ? n : Math.min(base, n);
          input.max = mx;
          input.disabled = mx <= 0;
          r.querySelectorAll('.ba-qty button').forEach(function (b) { b.disabled = mx <= 0; });
          if ((parseInt(input.value, 10) || 0) > mx) input.value = Math.max(0, mx);
        });
        updateSum();
      }
      function paintNote() {
        if (!note) return;
        var city = BA.city(view);
        if (!loaded) { note.hidden = true; return; }
        var here = 0, others = {};
        rows.forEach(function (r) { var p = parsed[r.getAttribute('data-vid')]; if (!p) return; here += p[view]; BA.CITIES.forEach(function (c) { if (c.col !== view) others[c.col] = (others[c.col] || 0) + p[c.col]; }); });
        var best = null;
        Object.keys(others).forEach(function (k) { if (others[k] > 0 && (!best || others[k] > others[best])) best = k; });
        var short = rows.some(function (r) { var p = parsed[r.getAttribute('data-vid')]; return p && p[view] <= 0 && BA.altWh(p, view); });
        if (here <= 0 && best) {
          note.hidden = false; note.className = 'ba-stock__note is-warn';
          note.innerHTML = '<b>Not in stock at ' + city.name + ' right now.</b> <span>' + fmt(others[best]) + ' pcs ready at ' + BA.city(best).name + '.</span> <button type="button" data-wh-go="' + best + '">Switch to ' + BA.city(best).name + '</button>';
        } else if (short) {
          note.hidden = false; note.className = 'ba-stock__note';
          note.innerHTML = '<span>Some sizes are not at ' + city.name + '. Tap the warehouse shown under a size to switch.</span>';
        } else note.hidden = true;
      }
      function paint() {
        box.setAttribute('data-view', view);
        tabs.forEach(function (t) { var on = t.getAttribute('data-view') === view; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
        box.querySelectorAll('[data-ba-wh-name]').forEach(function (e) { e.textContent = BA.city(view).name; });
        if (!loaded) return;
        rows.forEach(function (r) {
          var p = parsed[r.getAttribute('data-vid')];
          BA.CITIES.forEach(function (c) { cell(r.querySelector('[data-col="' + c.col + '"]'), p ? p[c.col] : null, p, c.col); });
        });
        filter(); lockQty(); paintNote();
      }
      function render(results) {
        var sums = { bangalore: 0, hyderabad: 0, mumbai: 0 };
        rows.forEach(function (r) {
          var vid = r.getAttribute('data-vid');
          var raw = results[vid];
          if (!raw) { parsed[vid] = null; return; }
          var p = BA.parseStock(raw); parsed[vid] = p;
          BA.CITIES.forEach(function (c) { sums[c.col] += p[c.col]; });
        });
        tabs.forEach(function (t) { var s = t.querySelector('span'); if (s) s.textContent = fmt(sums[t.getAttribute('data-view')] || 0); });
        loaded = true; paint();
      }
      function filter() {
        var on = hide && hide.checked && loaded;
        rows.forEach(function (r) { var p = parsed[r.getAttribute('data-vid')]; r.classList.toggle('is-hidden', !!(on && p && p[view] <= 0)); });
      }
      function load(fresh) {
        if (busy || !url) return; busy = true;
        if (refresh) { refresh.disabled = true; refresh.classList.add('is-spin'); }
        skeleton(); setStatus('Loading…');
        BA.fetchStock(url, ids, { fresh: fresh, onRetry: function (n) { setStatus('Retrying (' + n + '/3)…'); } })
          .then(function (d) { render(d); last = Date.now(); setStatus('Updated ' + new Date().toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })); })
          .catch(function () {
            box.querySelectorAll('td[data-col]').forEach(function (td) { if (td.querySelector('.ba-sk')) td.textContent = '—'; });
            tabs.forEach(function (t) { var s = t.querySelector('span'); if (s && s.querySelector('.ba-sk')) s.textContent = '—'; });
            setStatus("Couldn't load — tap refresh", true);
          })
          .then(function () { busy = false; if (refresh) { refresh.disabled = false; refresh.classList.remove('is-spin'); } });
      }
      tabs.forEach(function (t) { t.addEventListener('click', function () { BA.wh.set(t.getAttribute('data-view')); }); });
      box.addEventListener('click', function (e) { var b = e.target.closest('[data-wh-go]'); if (b) BA.wh.set(b.getAttribute('data-wh-go')); });
      BA.wh.on(function (wh) { view = wh; paint(); });
      if (hide) hide.addEventListener('change', filter);
      if (refresh) refresh.addEventListener('click', function () { load(true); });
      document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible' && last && Date.now() - last > 120000) load(true); });

      // Quantity steppers
      box.querySelectorAll('.ba-qty').forEach(function (q) {
        var input = q.querySelector('input');
        q.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            if (input.disabled) return;
            var min = parseInt(input.min || 0, 10), max = parseInt(input.max || 99999, 10);
            var v = (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-step'), 10);
            input.value = Math.min(isNaN(max) ? 99999 : max, Math.max(min, v)); updateSum();
          });
        });
        input.addEventListener('input', function () {
          var max = parseInt(input.max, 10);
          if (!isNaN(max) && (parseInt(input.value, 10) || 0) > max) input.value = max;
          updateSum();
        });
      });
      var sumEl = box.querySelector('[data-sum-pcs]');
      var sumAmt = box.querySelector('[data-sum-amt]');
      function updateSum() {
        var pcs = 0, amt = 0;
        box.querySelectorAll('.ba-qty input').forEach(function (i) { var n = parseInt(i.value, 10) || 0; pcs += n; amt += n * (parseInt(i.getAttribute('data-price'), 10) || 0); });
        if (sumEl) sumEl.textContent = pcs + (pcs === 1 ? ' pc' : ' pcs');
        if (sumAmt) sumAmt.textContent = amt ? (window.BA_MONEY ? BA_MONEY(amt) : '₹' + fmt(Math.round(amt / 100))) : '—';
      }
      updateSum();

      // Add to cart — one request for all sizes
      var addBtn = box.querySelector('[data-add]');
      var msg = box.querySelector('.ba-stock__msg');
      if (addBtn) addBtn.addEventListener('click', function () {
        var items = [];
        box.querySelectorAll('.ba-qty input').forEach(function (i) { var n = parseInt(i.value, 10) || 0; if (n > 0 && !i.disabled) items.push({ id: Number(i.getAttribute('data-vid')), quantity: n }); });
        if (!items.length) { msg.textContent = 'Choose a quantity for at least one size.'; msg.classList.add('is-err'); return; }
        addBtn.disabled = true; msg.classList.remove('is-err'); msg.textContent = 'Adding to cart…';
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items })
        }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add'); return j; }); })
          .then(function () { return BA.whCart ? BA.whCart() : null; })
          .then(function () { msg.textContent = 'Added. Taking you to your cart…'; setTimeout(function () { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; }, 700); })
          .catch(function (e) { msg.textContent = e.message; msg.classList.add('is-err'); addBtn.disabled = false; });
      });

      paint();
      if (!url) { setStatus('Live data not configured', true); return; }
      load(false);
    });
  }

  /* ---------- PDP gallery + sticky bar ---------- */
  function initGallery() {
    document.querySelectorAll('[data-ba-gal]').forEach(function (g) {
      var main = g.querySelector('.ba-gal__main img');
      g.querySelectorAll('.ba-gal__thumbs button').forEach(function (b) {
        b.addEventListener('click', function () {
          g.querySelectorAll('.ba-gal__thumbs button').forEach(function (x) { x.classList.remove('is-active'); });
          b.classList.add('is-active');
          main.src = b.getAttribute('data-src'); main.srcset = b.getAttribute('data-srcset') || '';
          main.alt = b.getAttribute('data-alt') || '';
        });
      });
    });
    var bar = document.querySelector('.ba-buybar');
    var target = document.querySelector('[data-ba-stock]');
    if (bar && target && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        var e = en[0];
        bar.classList.toggle('is-in', !e.isIntersecting && e.boundingClientRect.top > 0 || (!e.isIntersecting && e.boundingClientRect.bottom < 0));
      });
      io.observe(target);
    }
  }

  function init() {
    document.documentElement.classList.add('ba-js');
    initReveal(); initHeader(); initFilters(); initInventoryShowcase(); initProductStock(); initGallery();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { initReveal(); initFilters(); initInventoryShowcase(); initProductStock(); initGallery(); });
})();
